export default __webpack_public_path__ + "static/media/img_01.deea918a.jpg";